import { PropsWithChildren, useCallback, useMemo, useState } from 'react';

import {
  ContextValue,
  LeaveGuardModalConfig,
  LeaveGuardModalContext,
  ModalState,
} from '@shared/providers/LeaveGuardModalProvider/providerSetup.ts';

export function LeaveGuardModalProvider({ children }: PropsWithChildren) {
  const [modalState, setModalState] = useState<ModalState>({ isOpen: false, isLoading: false, isFormDirty: false });
  const [modalConfig, setModalConfig] = useState<LeaveGuardModalConfig | null>(null);

  const toggleModal = useCallback(() => setModalState((state) => ({ ...state, isOpen: !state.isOpen })), []);
  const closeModal = useCallback(() => setModalState((state) => ({ ...state, isOpen: false })), []);
  const setIsFormDirty = useCallback(
    (isDirty: boolean) => setModalState((state) => ({ ...state, isFormDirty: isDirty })),
    [],
  );
  const setIsLoading = useCallback((isLoading: boolean) => setModalState((state) => ({ ...state, isLoading })), []);

  const registerLeaveGuardConfig = useCallback((config: LeaveGuardModalConfig | null) => {
    setModalConfig(config);
  }, []);

  const value: ContextValue = useMemo(
    () => ({
      isOpen: modalState.isOpen,
      isLoading: modalState.isLoading,
      isFormDirty: modalState.isFormDirty,
      modalConfig,
      toggleModal,
      closeModal,
      setIsFormDirty,
      setIsLoading,
      registerLeaveGuardConfig,
    }),
    [
      modalState.isOpen,
      modalState.isLoading,
      modalState.isFormDirty,
      modalConfig,
      toggleModal,
      closeModal,
      setIsFormDirty,
      setIsLoading,
      registerLeaveGuardConfig,
    ],
  );

  return <LeaveGuardModalContext.Provider value={value}>{children}</LeaveGuardModalContext.Provider>;
}
